import React from "react";
import { Link } from "react-router-dom";

const getPosterUrl = (path) => {
    return `https://www.themoviedb.org/t/p/w220_and_h330_face${path}`;
}

function SearchCard({ movie }) {

    return (
        <>
        <Link to={`/movie-tv/search/${movie.id}`}>
        <div className="grid grid-cols-3 py-4">
            <div className="col-span-1">
                <img src={getPosterUrl(movie?.poster_path)} className="w-[150px] h-[225px] shadow-sm rounded-md" />
            </div>

            <div className="col-span-2 flex flex-col justify-center">
            <h4 className="font-bold">{movie?.original_title || movie?.title}</h4>
            </div>
        </div>
        </Link>
        </>
    );

}

export default SearchCard;
